export const initialState = {
    onlineStationsList: [],
  };